/**
 * Достаёт перечисленные query-параметры из URLSearchParams и возвращает новый URLSearchParams
 * По логике похоже на Pick из typescript
 *
 * @param search - строка ?param1=value1&param2=value2 или URLSearchParams
 * @param params - список ключей, например ['param1', 'param2']
 * @returns URLSearchParams
 */
export const pickQueryParams = (search: string | URLSearchParams, params: string[]): URLSearchParams => {
    const queryParams = new URLSearchParams(search);
    const resultParams = new URLSearchParams();

    params.forEach((paramKey) => {
        if (queryParams.has(paramKey)) {
            const value = queryParams.get(paramKey);
            resultParams.set(paramKey, value ?? '');
        }
    });

    return resultParams;
};
